import { useEffect, type ReactNode } from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export default function Modal({ open, onClose, title, children }: ModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title}>
      <div className="absolute inset-0 bg-secondary-950/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true"></div>
      <div className="relative z-10 w-full max-w-lg overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
          <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950">
            <i className="ri-information-line text-primary-500" aria-hidden="true"></i>
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-xl" aria-hidden="true"></i>
          </button>
        </div>
        <div className="px-5 py-5 text-sm leading-relaxed text-foreground-600">{children}</div>
      </div>
    </div>
  );
}